import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userState = useSelector((state) => state.UserReducer);
  if (!userState.token) {
    return <Navigate to={"/login"} replace />;
  }
  return children;
};

export default ProtectedRoute;
